import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { ActivatedRoute, Router } from '@angular/router';
  import { DatePipe } from '@angular/common';
  
  import { CampaignService } from '../../services/campaign.service';
  
  @Component({
    selector: 'app-campaign-detail',
    templateUrl: './campaign-detail.html',
    styleUrl: './campaign-detail.scss',
    imports: [DatePipe],
  })
  export class CampaignDetailComponent implements OnInit {
    private campaignService = inject(CampaignService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private cdr = inject(ChangeDetectorRef);
  
    campaign: any = null;
    isLoading = true;
  
    ngOnInit(): void {
      const campaignId =
        this.route.snapshot.paramMap.get('id');
  
      if (!campaignId) {
        this.router.navigate(['/admin/campaigns']);
        return;
      }
  
      this.loadCampaign(campaignId);
    }
  
    loadCampaign(id: string): void {
      this.isLoading = true;
  
      this.campaignService.getCampaign(id).subscribe({
        next: (response: any) => {
          console.log(
            '🟢 CAMPAÑA RECIBIDA:',
            response,
          );
  
          this.campaign =
            response.data.document;
  
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR CARGANDO CAMPAÑA:',
            error,
          );
  
          this.campaign = null;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }
  
    goBack(): void {
      this.router.navigate(['/admin/campaigns']);
    }
  }